<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Thêm mới yêu cầu</h4>
          </div>
          <div class="text-right"></div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <el-form ref="myForm" label-width="150px" label-position="top">
              <b-row>
                <b-col md="12">
                  <el-form-item label="Tiêu đề" prop="">
                    <el-input clearable></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-form-item label="Phân loại" prop="">
                    <el-select
                      clearable
                      filterable
                      v-model="phanLoai"
                      @change="changePhanLoai"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listPhanLoai"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="6" v-if="phanLoai == 'paid-leave'">
                  <span>Số ngày nghỉ phép còn lại: </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-form-item label="Lý do" prop="">
                    <el-select clearable filterable v-model="lyDo">
                      <el-option
                        v-for="item in mData.dataDefault.listLyDo"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item label="Nhân viên" prop="">
                    <el-select clearable filterable v-model="nhanVien">
                      <el-option
                        v-for="item in mData.dataDefault.listNhanVien"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col
                  md="6"
                  v-if="
                    phanLoai == 'paid-leave' || phanLoai == 'public-explanation'
                  "
                >
                  <el-form-item label="Thời gian từ" prop="">
                    <el-date-picker
                      clearable
                      v-model="dateFrom"
                      type="datetime"
                      fomart="dd/MM/yyyy HH:mm"
                      value-fomart="dd/MM/yyyy HH:mm"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col
                  md="6"
                  v-if="
                    phanLoai == 'paid-leave' || phanLoai == 'public-explanation'
                  "
                >
                  <el-form-item label="Thời gian tới" prop="">
                    <el-date-picker
                      clearable
                      v-model="dateTo"
                      type="datetime"
                      fomart="dd/MM/yyyy HH:mm"
                      value-fomart="dd/MM/yyyy HH:mm"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="6" v-if="phanLoai == 'late'">
                  <el-form-item label="Thời gian đi muộn" prop="">
                    <el-date-picker
                      clearable
                      v-model="timeLate"
                      type="datetime"
                      fomart="dd/MM/yyyy HH:mm"
                      value-fomart="dd/MM/yyyy HH:mm"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="6" v-if="phanLoai == 'come-back-soon'">
                  <el-form-item label="Thời gian về sớm" prop="">
                    <el-date-picker
                      clearable
                      v-model="timeComeBackSoon"
                      type="datetime"
                      fomart="dd/MM/yyyy HH:mm"
                      value-fomart="dd/MM/yyyy HH:mm"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row v-if="phanLoai == 'go-out'">
                <b-col md="6" class="d-flex">
                  <el-form-item label="Thời gian từ" prop="">
                    <el-time-picker clearable v-model="timeFrom">
                    </el-time-picker>
                  </el-form-item>
                  <el-form-item label="tới" prop="" id="time-to">
                    <el-time-picker clearable v-model="timeTo">
                    </el-time-picker>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item label="Ngày" prop="">
                    <el-date-picker
                      clearable
                      v-model="dayOff"
                      type="date"
                      fomart="dd/MM/yyyy"
                      value-fomart="dd/MM/yyyy"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" v-if="phanLoai == 'business-travel'">
                  <el-form-item label="Thời gian từ" prop="">
                    <el-date-picker
                      clearable
                      v-model="dayBTFrom"
                      type="date"
                      fomart="dd/MM/yyyy"
                      value-fomart="dd/MM/yyyy"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="6" v-if="phanLoai == 'business-travel'">
                  <el-form-item label="Thời gian tới" prop="">
                    <el-date-picker
                      clearable
                      v-model="dayBTTo"
                      type="date"
                      fomart="dd/MM/yyyy"
                      value-fomart="dd/MM/yyyy"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col
                  md="12"
                  class="mb-3"
                  style="margin-left: 30px"
                  v-if="phanLoai == 'business-travel'"
                >
                  <b-link href="javascript:">Tuỳ chọn nâng cao</b-link>
                </b-col>
                <b-col md="12">
                  <el-form-item label="Chi tiết" prop="">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <el-form-item class="text-center mt-3">
                <el-button
                  type="primary"
                  round
                  @click="fn_submitForm('create')"

                  >Thêm mới</el-button
                >

                <el-button
                  type="primary"
                  round
                  @click="fn_submitForm('update')"

                  >Lưu</el-button
                >

                <el-button type="primary" round @click="fn_go()"
                  >Quay lại</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import RequestsModel from "./RequestsModel";

export default {
  data() {
    return {
      phanLoai: undefined,
      nhanVien: undefined,
      lyDo: undefined,
      dateFrom: undefined,
      dateTo: undefined,
      timeLate: undefined,
      timeComeBackSoon: undefined,
      timeFrom: undefined,
      timeTo: undefined,
      dayOff: undefined,
      dayBTFrom: undefined,
      dayBTTo: undefined,
      mData: {
        data: [],
        moduleName: "YeuCau", //requied
        tableRules: MethodService.copyObject(RequestsModel.tableRules),
        dataDefault: {
          listPhanLoai: [
            {
              value: "paid-leave",
              label: "Nghỉ có lương",
            },
            {
              value: "public-explanation",
              label: "Giải trình công",
            },
            {
              value: "late",
              label: "Đi muộn",
            },
            {
              value: "come-back-soon",
              label: "Về sớm",
            },
            {
              value: "go-out",
              label: "Ra ngoài",
            },
            {
              value: "business-travel",
              label: "Đi công tác",
            },
          ],
          listNhanVien: [],
          listLyDo: [],
        },
      },
    };
  },

  methods: {
    fn_initTable() {},
    changePhanLoai() {
      // console.log("phanLoai", this.phanLoai);
    },
  },

  //run after render view
  created() {},
  mounted() {},
};
</script>
<style scoped>
#time-to {
  margin-left: 15px;
}
::v-deep #time-to .el-form-item__label {
  width: 40px !important;
}
::v-deep #time-to .el-form-item__content {
  margin-left: 40px !important;
}
</style>
